<div
  class="pill-strip"
  [ngClass]="customWrapperClass"
  *ngIf="items && items.length > 0"
>
  <span class="pill-strip__label" *ngIf="label">
    {{ label }}
  </span>
  <div
    class="pill-item"
    *ngFor="let item of items; let idx = index"
    [class.selected]="isSelected(item, idx)"
    [class.dead]="item.dead"
    (click)="selectItem(item, idx)"
  >
    <span
      class="dot"
      [ngClass]="getDotClass(item)"
      [style.backgroundColor]="item.dotColor"
    ></span>
    <span class="pill-label">{{ item.label }}</span>
    <span class="pill-sublabel" *ngIf="item.subLabel || item.note">
      · {{ item.subLabel || item.note }}
    </span>
  </div>
</div>
